import React, { useState } from "react";
import { Box, Typography } from "@mui/material";
import { motion } from "framer-motion";
import Image from "next/image";
import "./marketing.css";
import { cities } from "../footer/footerCityData";

const imageVariants = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0, transition: { duration: 1 } },
};

const sectionWrapSx = {
  width: "100%",
  maxWidth: "min(92%, 1220px)",
  marginLeft: "auto",
  marginRight: "auto",
  paddingX: { xs: 2, sm: 3 },
  boxSizing: "border-box" as const,
};

const StateAvailable = () => {
  const [hoverIndex, setHoverIndex] = useState<number | null>(null);

  return (
    <Box
      sx={{
        textAlign: "center",
        padding: { xs: "1.5rem 0 2rem", sm: "2rem 0 3rem" },
        marginBottom: { xs: 0, sm: "1rem" },
        pb: { xs: 2, sm: 0 },
      }}
    >
      <Box sx={{ ...sectionWrapSx, textAlign: "center" }}>
        <Typography
          variant="h4"
          component="h2"
          sx={{
            fontWeight: 700,
            marginBottom: { xs: "0.75rem", sm: "1rem" },
            color: "#123524",
            textAlign: "center",
            fontSize: { xs: "1.5rem", sm: "2rem" },
          }}
          className="franchise-state-heading"
        >
          States we are in
        </Typography>
      </Box>

      <Box
        sx={{
          ...sectionWrapSx,
          pt: 0.5,
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center",
          alignItems: "stretch",
          gap: { xs: 1.5, sm: 2 },
        }}
      >
        {cities &&
          cities
            ?.sort((a, b) => a.name.localeCompare(b.name))
            .map((item, index) => (
              <Box
                key={index}
                sx={{
                  flex: { xs: "1 1 100%", sm: "0 1 280px" },
                  maxWidth: { xs: "320px", sm: "320px" },
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignSelf: "flex-start",
                  mx: { xs: "auto", sm: 0 },
                }}
              >
                <motion.div
                  initial="hidden"
                  whileInView="visible"
                  variants={imageVariants}
                  viewport={{ once: true }}
                  className="state-hover-effect"
                  onMouseEnter={() => setHoverIndex(index)}
                  onMouseLeave={() => setHoverIndex(null)}
                  style={{
                    position: "relative",
                    overflow: "hidden",
                    borderRadius: "10px",
                    marginTop: hoverIndex === index ? "-8px" : "0px",
                    transition:
                      "margin-top 0.5s ease-in-out, transform 0.5s ease-in-out",
                    width: "100%",
                    maxWidth: "320px",
                  }}
                >
                  {/* Image with Hover Zoom & Move-up Effect */}
                  <Image
                    src={item.url}
                    alt={item.name}
                    height={1000}
                    width={1000}
                    style={{
                      width: "100%",
                      height: "auto",
                      minHeight: "11rem",
                      maxHeight: "11rem",
                      borderRadius: "10px",
                      objectFit: "cover",
                      transform:
                        hoverIndex === index ? "scale(1.2)" : "scale(1)",
                      transition: "transform 5s ease-in-out",
                    }}
                  />

                  {/* Gradient Overlay */}
                  <Box
                    sx={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                      background:
                        "linear-gradient(to top, rgba(0, 0, 0, 0.4), transparent)",
                      opacity: hoverIndex === index ? 1 : 0,
                      transition: "opacity 0.4s ease-in-out",
                    }}
                  />

                  {/* City Name Overlay */}
                  <Box
                    sx={{
                      position: "absolute",
                      bottom: 0,
                      left: 0,
                      width: "100%",
                      padding: "8px 0",
                      textAlign: "center",
                    }}
                  >
                    <Typography
                      variant="h6"
                      sx={{ color: "#fff", fontWeight: "bold" }}
                    >
                      {item.name}
                    </Typography>
                  </Box>
                </motion.div>
              </Box>
            ))}
      </Box>
    </Box>
  );
};

export default StateAvailable;
